import { AbsoluteFill, useCurrentFrame, useVideoConfig, random, interpolate } from "remotion";
import React from "react";

// VFX: Atmospheric Smoke Drift
// Category: overlays · Tags: smoke, atmospheric, particles, cinematic, moody
export default function FxSmokeAtmosphericDrift3000Ms() {
  const frame = useCurrentFrame();
  const { width, height } = useVideoConfig();
  const puffs = Array.from({ length: 14 }, (_, i) => {
    const seed = `s-${i}`;
    const baseX = random(`x-${i}`) * width;
    const baseY = random(`y-${i}`) * height;
    const driftX = Math.sin(frame * 0.01 + i) * 60;
    const driftY = -frame * (0.15 + random(`v-${i}`) * 0.2);
    const size = 240 + random(`sz-${i}`) * 320;
    const opacity = 0.04 + random(`o-${i}`) * 0.12;
    const hue = 200 + random(`h-${i}`) * 40;
    return {
      x: baseX + driftX,
      y: ((baseY + driftY) % (height + 400) + height + 400) % (height + 400) - 200,
      size, opacity, hue
    };
  });
  const vignette = interpolate(frame, [0, 30], [0, 0.5], { extrapolateRight: "clamp" });

  return (
    <AbsoluteFill style={{ background: "#0a0e1a", overflow: "hidden" }}>
      {puffs.map((p, i) => (
        <div key={i} style={{
          position: "absolute",
          left: p.x - p.size / 2,
          top: p.y - p.size / 2,
          width: p.size, height: p.size,
          borderRadius: "50%",
          background: `radial-gradient(circle, hsla(${p.hue}, 30%, 60%, ${p.opacity}) 0%, transparent 70%)`,
          filter: "blur(40px)",
          mixBlendMode: "screen",
        }} />
      ))}
      <div style={{
        position: "absolute", inset: 0,
        background: `radial-gradient(ellipse at center, transparent 30%, rgba(0,0,0,${vignette}) 100%)`,
        pointerEvents: "none"
      }} />
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
